import { createFileRoute } from '@tanstack/react-router';

import { IntakeView } from 'src/sections/white-glove/intake/intake-view';

/**
 * The five-step intake (F1). A tab rather than a modal takeover: the customer
 * has to leave it to import a brand or connect an ESP, and coming back to a
 * route is easier than reopening a wizard.
 *
 * `?step=` is how the dashboard checklist opens one question in particular.
 * Without it the wizard opens on whatever the server says is next, which is the
 * right answer for someone who clicked "Continue setup" and the wrong one for
 * someone who clicked the third row of a list.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/intake')({
  validateSearch: (search: Record<string, unknown>) => ({
    step: search.step as
      | 'siteScrape'
      | 'integrations'
      | 'inspiration'
      | 'cadence'
      | 'commitments'
      | undefined,
  }),
  component: WgIntakePage,
});

function WgIntakePage() {
  return <IntakeView />;
}
